import { useReadScripts } from '@/features/_data/useScripts';
import { Unit } from '@/types/Unit';
import React, { useEffect, useState } from 'react';

type Props = {
  unit: Unit | undefined;
  unitId: string;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};
export function useScriptInitialization({ unit, unitId, setIsDirty }: Props) {
  // Editing mode state (code editor vs visual editor)
  const [isEditingCode, setIsEditingCode] = useState(false);

  useEffect(() => {
    if (unit) {
      setIsEditingCode(!unit.logicEditorEnabled);
    }
  }, [unit]);
  // fetch script data for code editor
  const {
    data: script,
    refetch: refetchScript,
    isLoading: isLoadingScript,
    isSuccess: isSuccessScript,
    isError: isErrorScript,
    isRefetching: isRefetchingScript,
  } = useReadScripts(unitId ?? '');
  const [code, setCode] = useState<string>('');

  useEffect(() => {
    if (unit) {
      setIsEditingCode(!unit.logicEditorEnabled);
    }
  }, [unit]);

  useEffect(() => {
    if (unit && isEditingCode !== !unit.logicEditorEnabled) {
      setIsDirty(true);
    }
    if (!isEditingCode && script?.script) {
      setCode(script.script);
    }
  }, [isEditingCode, unit]);

  useEffect(() => {
    if (code === '' || code === script?.script) {
      return;
    }
    setIsDirty(true);
  }, [code]);
  return {
    script,
    refetchScript,
    code,
    setCode,
    isLoadingScript,
    isRefetchingScript,
    isEditingCode,
    setIsEditingCode,
    isSuccessScript,
    isErrorScript,
  };
}
